import glamorous from 'glamorous';
import React from 'react';
import { Colors, NavProvider, Sizes, BrandonGrotesque } from 'module/View/Common';
import { connect } from 'react-redux';
import { createPureComponent, PathUtils } from 'module/Common';
import { MenuAction, MenuSelector } from 'module/Redux/Menu';
import { MenuIcon } from 'module/View/Menu/icons/MenuIcon';
import { ReduxCompatibleDispatch } from 'lib/redux-stabilizer';
import { RouterSelector } from 'module/Redux/Router';
import { State } from 'module/Redux';

type WrapperProps = {
  adminBar: number;
  paddingRight: number;
  paddingLeft: number;
};

const Wrapper = glamorous.div<WrapperProps>(p => ({
  height: Sizes.menuTopBarHeight,
  position: 'fixed',
  top: p.adminBar,
  left: 0,
  right: 0,
  background: 'white',
  zIndex: 980,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  paddingRight: p.paddingRight,
  paddingLeft: p.paddingLeft,
}));

const LangLink = glamorous.a({
  color: Colors.mobileMenu.blue,
  fontSize: 20,
  lineHeight: '30px',
  textDecoration: 'none',
  marginLeft: Sizes.smallGutter,
  marginRight: 0,
  fontFamily: BrandonGrotesque.mediumItalic,
  fontStyle: 'normal',
  fontWeight: 'normal',
  cursor: 'pointer',
  ':hover': {
    color: Colors.mobileMenu.blueHover,
  },
});

const Toggle = glamorous.div({
  cursor: 'pointer',
  marginLeft: -12,
});

type StateProps = {
  open: boolean;
  otherLang: PathUtils.Lang;
};

const mapStateToProps = (s: State): StateProps => ({
  open: MenuSelector.isOpen(s),
  otherLang: RouterSelector.selectOtherLang(s),
});

type DispatchProps = {
  toggle: () => void;
};

const mapDispatchToProps = (dispatch: ReduxCompatibleDispatch): DispatchProps => ({
  toggle: () => dispatch(MenuAction.toggleOpen()),
});

type OwnProps = {
  adminBarHeight: number;
  windowWidth: number;
};

type Props = StateProps & DispatchProps & OwnProps;

const MenuTopBarComp = createPureComponent<Props>(
  'MenuTopBar',
  ({ adminBarHeight, open, toggle, otherLang, windowWidth }) => {
    return (
      <Wrapper
        adminBar={adminBarHeight}
        paddingRight={Sizes.getContentMargins(windowWidth)[1]}
        paddingLeft={Sizes.getContentMargins(windowWidth)[3]}
      >
        <Toggle onClick={() => toggle()}>
          <MenuIcon open={open} />
        </Toggle>
        <div style={{ flex: 1 }} />
        <NavProvider lang={otherLang}>
          {params => <LangLink {...params.getAnchorProps()}>{otherLang === 'fr' ? 'Français' : 'English'}</LangLink>}
        </NavProvider>
      </Wrapper>
    );
  }
);

export const MenuTopBar = connect(mapStateToProps, mapDispatchToProps)(MenuTopBarComp);



// WEBPACK FOOTER //
// ./src/module/View/Menu/TopBar/MenuTopBar.tsx